import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const BlogsSection = ({ id }) => {
  const [blogs, setBlogs] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const response = await corefetch(`Blog/GetLatestBlogs?Id=${id}`);
        if (response && response.length > 0) {
          setBlogs(response);
        } else {
          setBlogs([]);
          console.error("No blog data found");
        }
      } catch (error) {
        setBlogs([]);
        console.error("Failed to fetch blog data", error);
      }
    };

    fetchBlogData();
  }, []);

  useEffect(() => {
    if (blogs?.length) {
      function sortingGallery() {
        if ($(".sortable-gallery .gallery-filters").length) {
          var $container = $(".gallery-container");
          $container.isotope({
            filter: "*",
            animationOptions: {
              duration: 750,
              easing: "linear",
              queue: false,
            },
          });

          $(".gallery-filters li a").on("click", function () {
            $(".gallery-filters li .current").removeClass("current");
            $(this).addClass("current");
            var selector = $(this).attr("data-filter");
            $container.isotope({
              filter: selector,
              animationOptions: {
                duration: 750,
                easing: "linear",
                queue: false,
              },
            });
            return false;
          });
        }
      }
    }
  }, [JSON.stringify(blogs)]);

  if (!blogs || blogs.length === 0) {
    return null;
  }

  return (
    <section className="wpo-blog-section section-padding">
      <div className="container">
        <div className="wpo-section-title">
          <h4>Blogs</h4>
          {id === 0 ? (
            <h2>Read Our Latest Blogs</h2>
          ) : (
            <h2>Read Our {blogs[0].displayedInName} News</h2>
          )}
        </div>
        <div className="wpo-blog-items">
          <div className="sortable-gallery">
            <div className="gallery-filters" />
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="wpo-blog-grids gallery-container clearfix"
                  style={{ position: "relative", height: "560.812px" }}
                >
                  {blogs.map((blog, index) => {
                    const leftPosition =
                      index === 0 ? 0 : isSmallScreen ? 700 : 573;
                    const topPosition = index === 0 ? 0 : 180 * (index - 1);

                    const eventDate = new Date(blog.createdDate);
                    const day = eventDate.getDate();
                    const month = eventDate.toLocaleString("default", {
                      month: "short",
                    });

                    if (index === 0) {
                      const formattedDate = eventDate.toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        }
                      );
                      return (
                        <div
                          key={blog.blogsID}
                          className="grid"
                          style={{
                            position: "absolute",
                            left: `${leftPosition}px`,
                            top: `${topPosition}px`,
                          }}
                        >
                          <div className="wpo-blog-item">
                            <div className="wpo-blog-img">
                              <img
                                src={`${ImageURL}${blog.imagePath}`}
                                alt={blog.title}
                                className="img-fluid"
                                style={{
                                  width: "100%",
                                  height: "400px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div className="wpo-blog-content">
                              <h2>
                                <a href={`/blogdetail/${blog.blogsID}`}>
                                  {blog.title}
                                </a>
                              </h2>
                              <p>{blog.content}</p>
                              <ul>
                                <li>{formattedDate}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      const formattedDate = eventDate.toLocaleDateString(
                        "en-US",
                        {
                          month: "short",
                          day: "numeric",
                          year: "numeric", // "Day Month Year" format
                        }
                      );

                      return (
                        <div
                          key={blog.blogsID}
                          className="grid"
                          style={{
                            position: "absolute",
                            left: `${leftPosition}px`,
                            top: `${topPosition}px`,
                          }}
                        >
                          <div className="wpo-blog-item">
                            <div className="wpo-blog-img">
                              <img
                                src={`${ImageURL}${blog.imagePath}`}
                                alt={blog.title}
                                className="img-fluid"
                                style={{
                                  width: "100%", // Make the image fill the container
                                  height: "140px", // Set height for the other images
                                  objectFit: "cover", // Ensure the image covers the container and doesn't stretch
                                }}
                              />
                            </div>
                            <div className="wpo-blog-content">
                              <h2>
                                <a href={`/blogdetail/${blog.blogsID}`}>
                                  {blog.title}
                                </a>
                              </h2>
                              <p>{blog.content}</p>
                              <ul>
                                <li>{formattedDate}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogsSection;
